import React, { useContext } from "react";
import { View, Platform } from "react-native";
import ThemeContext from "@presto-contexts/ThemeContext";
import TextTicker from "react-native-text-ticker";

export default function Marquee({
  paddingHorizontal,
  bgColor,
  fontWeight,
  text,
  width,
  textStyles = {},
  alignItems,
}) {
  const { theme } = useContext(ThemeContext);
  if (Platform.OS === "web") {
    return (
      <div
        className="marquees"
        style={{
          flex: 1,
          flexDirection: "row",
          backgroundColor: bgColor || theme.primary,
          color: theme.white,
          width: "100%",
          alignItems: alignItems || "center",
          height: 36,
        }}
      >
        <div
          style={{
            fontSize: 16,
            fontWeight: fontWeight || "400",
            fontFamily: theme.primaryFont,
            backgroundColor: bgColor || theme.primary,
            color: theme.white,
            ...textStyles,
          }}
        >
          {text}
        </div>
      </div>
    );
  } else {
    return (
      <View
        style={{
          backgroundColor: bgColor || theme.primary,
          color: theme.white,
          padding: 10,
          paddingHorizontal: paddingHorizontal || 10,
          width: width,
          alignItems: alignItems,
        }}
      >
        <TextTicker
          style={{
            fontSize: 16,
            fontWeight: fontWeight || "400",
            fontFamily: theme.primaryFont,
            backgroundColor: bgColor || theme.primary,
            color: theme.white,
            width: "100%",
            ...textStyles,
          }}
          duration={10000}
          loop
          bounce={false}
          repeatSpacer={50}
          shouldAnimateTreshold={40}
          marqueeDelay={0}
        >
          {text}
        </TextTicker>
      </View>
    );
  }
}
